const context = require.context('./', true, /^\.\/(?!index).*?\.json$/)

const modules = {}

context.keys().forEach(key => {
  const name = key.replace(/\.\/(.*)?\.json/, (str, $1) => $1)
  modules[name] = context(key)
})

export default modules
